import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeSavedLocations } from './normalize';

export const fetchSavedLocations = createProvider(
  async (params: api.SavedLocationsRequestParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
    const response = await api.fetchSavedLocations(params, { signal });
    return normalizeSavedLocations(response);
  },
);
